module.exports = "build/assets/phone.d8c7896d.png";